import { createContext, useCallback, useContext, useEffect, useState } from "react";
import {
  clearAllSession,
  getCompanyId,
  getToken,
  setCompanyId as writeCompanyId,
  setToken as writeToken,
  subscribeSession,
} from "../helpers/session";

const AuthContext = createContext({
  companyId: null,
  token: null,
  isAuthenticated: false,
  setCompanyId: () => {},
  setToken: () => {},
  logout: () => {},
});

const snapshot = () => ({
  companyId: getCompanyId(),
  token: getToken(),
});

export const AuthProvider = ({ children }) => {
  const [state, setState] = useState(snapshot);

  useEffect(() => {
    const refresh = () => setState(snapshot());
    const unsub = subscribeSession(refresh);
    const onStorage = (e) => {
      if (!e.key || ["apiToken", "companyId"].includes(e.key)) refresh();
    };
    window.addEventListener("storage", onStorage);
    return () => {
      unsub();
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  const setCompanyId = useCallback((id) => writeCompanyId(id), []);
  const setToken = useCallback((t) => writeToken(t), []);
  const logout = useCallback(() => clearAllSession(), []);

  const value = {
    companyId: state.companyId,
    token: state.token,
    isAuthenticated: state.token !== null,
    setCompanyId,
    setToken,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
export const useCompanyId = () => useContext(AuthContext).companyId;
export const useCompanyIdNumber = () => {
  const id = useContext(AuthContext).companyId;
  return id === null ? null : Number(id);
};
export const useToken = () => useContext(AuthContext).token;
export const useIsAuthenticated = () => useContext(AuthContext).isAuthenticated;
